export default __webpack_public_path__ + "static/media/Warlord's Staff.6d1ec286.jpg";